module.exports = __webpack_public_path__ + "static/media/orl1.png.97e9bb26.jpg";